export default __webpack_public_path__ + "static/media/ISO 45K 2027-2.89efc33b.png";